export const phone = '606645281'
export const phoneFormatted = '606 645 281'

export const email = 'info@psychologicka-poradna-tabor.cz'
export const GOOGLE_ANALYTICS_ID = 'UA-133744585-1'
